import { gql, useMutation } from "@apollo/client";

import { USER_FIELDS, type UserType } from "@/store";

const GET_OR_CREATE_USER = gql`
  ${USER_FIELDS}

  mutation GetOrCreateUser($facebookId: Int, $idToken: String!, $inviteCode: String) {
    getOrCreateUser(facebookId: $facebookId, idToken: $idToken, inviteCode: $inviteCode) {
      user {
        ...UserFields
      }
    }
  }
`;

interface GetOrCreateUserDataType {
  getOrCreateUser: {
    user: UserType;
  };
}

interface GetOrCreateUserVariablesType {
  facebookId?: number;
  idToken: string;
  inviteCode?: string;
}

export default function useGetOrCreateUser() {
  return useMutation<GetOrCreateUserDataType, GetOrCreateUserVariablesType>(
    GET_OR_CREATE_USER
  );
}
